import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { WifiOff, Wifi } from 'lucide-react';

export function useOnlineStatus() {
  const getInitial = () => (typeof navigator !== 'undefined' ? navigator.onLine : true);
  const [online, setOnline] = useState(getInitial);
  useEffect(() => {
    const goOnline = () => {
      setOnline(true);
      toast.success('Back online', { description: 'Your changes will be saved.', duration: 3000 });
    };
    const goOffline = () => {
      setOnline(false);
      toast.error("You're offline", { description: 'Reconnect to save changes.', duration: 6000 });
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);
  return online;
}

export default function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      data-testid="offline-banner"
      className="sticky top-14 z-40 flex items-center gap-2 px-4 py-2 bg-amber-100 border-b border-amber-300 text-amber-900 text-xs font-medium"
    >
      <WifiOff className="h-3.5 w-3.5" />
      <span>You're offline — reconnect to save changes. Read-only mode.</span>
    </div>
  );
}

export { Wifi };
